import { formatPrice } from '@ab-core/functions';
import type { BestPrice, BestPriceBonus } from '@ab-core/graphql/dist/index';
import useText from '@ab-core/localization/src/useText';
import Spacer from '@ab-core/spacer';
import Text, { FontTypes } from '@ab-core/text';
import type { MoneyObject } from '@ab-core/types/src';
import type { FC } from 'react';
import React from 'react';
import { Colum, Divider } from '.././styled';

type BestPriceProps = BestPrice & {
    quantityUnit: string;
    priceReference?: number;
};

export const BestPriceList: FC<BestPriceProps> = (props) => {
    const { bestPriceBonus, quantityUnit, priceReference, value } = props;
    const bestPriceText = useText('priceCalculation.bestPrice');

    const getBestPrice = (): string => {
        if (!value) {
            return '-';
        }

        if (typeof value.centAmount !== 'number' || value.centAmount <= 0) {
            return '-';
        }

        return formatPrice(value as MoneyObject);
    };

    const getBestPriceName = (bestPriceValue: BestPriceBonus): string => {
        const name = bestPriceValue?.name || '';
        const percent = bestPriceValue?.percent ? `${bestPriceValue.percent}%` : '';

        return `${name} ${percent}`.trim();
    };

    const getBestPriceValue = (bestPriceValue: BestPriceBonus): string => {
        if (!bestPriceValue?.value) {
            return '';
        }

        return `- ${formatPrice(bestPriceValue.value)}`;
    };

    const renderBestPriceBonus = () => {
        if (!bestPriceBonus) {
            return <></>;
        }

        return bestPriceBonus.map((bestPriceValue, index) => (
            <Colum key={index}>
                <Text content={getBestPriceName(bestPriceValue)} />
                <Spacer size="xs" />
                <Text color="success" content={getBestPriceValue(bestPriceValue)} />
            </Colum>
        ));
    };

    return (
        <>
            <Text type={FontTypes.Title} content={`Ihre Vorteile pro ${priceReference} ${quantityUnit}`} />
            {renderBestPriceBonus()}
            <Spacer size="xs" />
            <Divider />
            <Spacer size="xs" />
            <Colum>
                <Text content={bestPriceText} />
                <Text type={FontTypes.Price} content={getBestPrice()} />
            </Colum>
        </>
    );
};
